 import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';

export const GlobalBackdrop = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    const hide = () => setOpen(false);

    window.addEventListener('show-spinner', show);
    window.addEventListener('hide-spinner', hide);

    return () => {
      window.removeEventListener('show-spinner', show);
      window.removeEventListener('hide-spinner', hide);
    };
  }, []);

  if (!open) return null;

  return (<div className="loading-container-red" >
    <Spinner color="primary" className="mb-1" />
  </div>);
};


export default GlobalBackdrop;